import { computed, DestroyRef, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChatFeedbackService {
  private readonly trigger = signal<(() => void) | null>(null);

  readonly available = computed(() => this.trigger() !== null);

  register(trigger: () => void, destroyRef: DestroyRef): void {
    this.trigger.set(trigger);
    destroyRef.onDestroy(() => {
      if (this.trigger() === trigger) {
        this.trigger.set(null);
      }
    });
  }

  request(): void {
    this.trigger()?.();
  }
}
